import Header from '../../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../../utils/Loader';
import { useForm } from "react-hook-form";
import {Link, useParams } from 'react-router-dom';
import VideoDelete from "./VideoDelete";

import { toast } from 'react-toastify';
import { useShowVideoQuery,useAddVideoMutation } from "../../../Services/api";
export default function EditVideo() {
    const { id } = useParams();
    const {
        data: ShowVideo,
        isLoading: isGetLoading,
      } = useShowVideoQuery({params:id});
   
    const notify = () => '';
    const { register, handleSubmit, formState: { errors }} = useForm();
    const [AddVideo,isLoading] = useAddVideoMutation();
    const onSubmit = (values,e) => {
        const formData = new FormData();
        formData.append('lod_id',id);
        formData.append('title', values.title);
        formData.append('file', values.file[0]);
        formData.append('old_name', values.old_name);
        AddVideo(formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
   
      if(isGetLoading) return  <Loader></Loader>
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Learning Outcome Video</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                        <li className="nav-item flex-fill" role="presentation">
                           <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Learning Outcome Details Video</button>
                        </li>
                        
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                <h5 className="card-title">Add Video </h5>
                                                <form onSubmit={handleSubmit(onSubmit)} className='table-responsive' >

                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th className='text-capitalize'>Name</th>
                                                                <th className='text-capitalize'>Old Name</th>
                                                                <th className='text-capitalize'>Video</th>
                                                                <th className='text-capitalize'>action</th>
                                                            </tr>
                                                        </thead>                            
                                                        <tbody>
                                                           <tr>
                                                                <td>
                                                                    <input type="text" {...register('title')} className="form-control" />
                                                                    <span className="text-danger">{errors.title?.message}</span>
                                                                </td>
                                                                <td>
                                                                    <input type="text" {...register('old_name')} className="form-control" />
                                                                     <span className="text-danger">{errors.old_name?.message}</span>

                                                                </td>
                                                                <td>
                                                                    <input type="file" {...register('file' ,{ required: true })} className="form-control" />
                                                                    <span className="text-danger">{errors.file?.message}</span>

                                                                </td>
                                                                <td>
                                                                    <div className="col-sm-10">
                                                                        {isLoading.status !='pending' ?    
                                                                            <button type="submit" className="btn btn-warning w-100" >Add Video</button>
                                                                                    :
                                                                            <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                                                        }
                                                                    </div>
                                                                </td>
                                                           
                                                          
                                                            </tr> 
                                                        </tbody>
                                                </table> 
                                                </form>                       
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                <h5 className="card-title">Video Details</h5>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>Name</th>
                                                                <th className='text-capitalize'>Old Name</th>
                                                                <th className='text-capitalize'>Video</th>
                                                                <th className='text-capitalize'>action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            ShowVideo.data !=0 ? 
                                                            ShowVideo && ShowVideo?.data?.map((item) => {
                                                            return (
                                                                <tr key={item.id}>
                                                                    <th scope="row">{item.id}</th>
                                                                    <td>{item?.title}</td>
                                                                    <td>{item?.old_name}</td> 
                                                                    <td className='text-primary'><Link className='text-primary' to={item.video} target="_blank" >Video</Link></td>
                                                                    
                                                                
                                                                    <td>
                                                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">

                                                                        <div className="btn-group" role="group">
                                                                            <button id="btnGroupDrop1" type="button" className="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            Action
                                                                            </button>
                                                                            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                                                
                                                                              <VideoDelete id={item.id} />
                                                                            </div>
                                                                        </div>
                                                                        </div>
                                                                    </td>                                                                 
                                                                </tr>                                            
                                                                )   
                                                            })
                                                            :
                                                            'data not found'  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
               
            </div>

            </main>
          
        </div>
    );
}
